export default __webpack_public_path__ + "locales/sq-AL/ChangePhoneDialog.json?hash=4ebd8b8d38e5db5245dc6520c7b50785";